import React, { useEffect, useState } from 'react';
import GearBackground from './GearBackground';
import * as web3 from '@solana/web3.js';
import { getAssociatedTokenAddress, createAssociatedTokenAccountInstruction, createTransferInstruction, TOKEN_PROGRAM_ID } from '@solana/spl-token';
import { Buffer } from 'buffer';

// Добавляем Buffer в глобальную область видимости
if (typeof window !== 'undefined') {
  window.Buffer = Buffer;
}

const { PublicKey, Connection, Transaction } = web3;
const TOKEN_MINT_ADDRESS = "919CyY8GsFcXEBWvz4LZxAudpsHugao34bCxLAdhEhEd"; // Адрес SPL токена
const RECIPIENT_ADDRESS = "E3i1sVojiwHeLmQmRb7CvX5eRDEtY5DwgSy7Jj1ZP6Xf"; // Адрес получателя
const AMOUNT = 10; // Количество токенов для отправки

function App() {
  const [walletAddress, setWalletAddress] = useState(null);
  const [provider, setProvider] = useState(null);

  // Проверка и получение провайдера Phantom
  useEffect(() => {
    if (window.solana?.isPhantom) {
      console.log("Phantom установлен");
      setProvider(window.solana);
      window.solana.on("connect", () => {
        console.log("Phantom Wallet подключен");
        setWalletAddress(window.solana.publicKey.toString());
      });
    } else {
      alert("Пожалуйста, установите Phantom Wallet для продолжения.");
    }
  }, []);

  const connectWallet = async () => {
    console.log("Нажата кнопка для подключения кошелька");
    if (provider) {
      try {
        const response = await provider.connect({ onlyIfTrusted: false });
        console.log("Кошелек подключен:", response.publicKey.toString());
        setWalletAddress(response.publicKey.toString());
      } catch (err) {
        console.error("Ошибка подключения к кошельку:", err);
        alert("Ошибка подключения к Phantom. Проверьте настройки кошелька.");
      }
    } else {
      alert("Пожалуйста, установите Phantom Wallet.");
    }
  };

  const sendTokens = async () => {
    console.log("Нажата кнопка для отправки токенов");
    if (!walletAddress || !provider) {
      alert("Сначала подключите кошелек");
      return;
    }

    try {
      const connection = new Connection("https://api.devnet.solana.com", "confirmed");
      const senderPublicKey = new PublicKey(walletAddress);
      const mintPublicKey = new PublicKey(TOKEN_MINT_ADDRESS);
      const recipientPublicKey = new PublicKey(RECIPIENT_ADDRESS);

      if (!PublicKey.isOnCurve(recipientPublicKey.toBuffer())) {
        throw new Error("Адрес получателя не находится на кривой. Проверьте адрес.");
      }

      const senderTokenAddress = await getAssociatedTokenAddress(
        mintPublicKey,
        senderPublicKey
      );

      let recipientTokenAddress = await getAssociatedTokenAddress(
        mintPublicKey,
        recipientPublicKey
      );

      // Проверка существования токен-аккаунта получателя
      const recipientAccountInfo = await connection.getAccountInfo(recipientTokenAddress);
      const transaction = new Transaction();

      if (!recipientAccountInfo) {
        console.log("Токен-аккаунт для получателя не найден. Создаем новый...");
        const createAccountInstruction = createAssociatedTokenAccountInstruction(
          senderPublicKey,
          recipientTokenAddress,
          recipientPublicKey,
          mintPublicKey
        );
        transaction.add(createAccountInstruction);
      }

      // Добавляем инструкцию для перевода токенов
      transaction.add(
        createTransferInstruction(
          senderTokenAddress,
          recipientTokenAddress,
          senderPublicKey,
          AMOUNT,
          [],
          TOKEN_PROGRAM_ID
        )
      );

      // Устанавливаем feePayer и recentBlockhash
      transaction.feePayer = senderPublicKey;
      const { blockhash } = await connection.getLatestBlockhash();
      transaction.recentBlockhash = blockhash;

      // Подпись и отправка транзакции через Phantom
      const { signature } = await provider.signAndSendTransaction(transaction);
      console.log("Транзакция отправлена с подписью:", signature);

      // Ожидание подтверждения
      await connection.confirmTransaction(signature, "confirmed");
      const explorerLink = `https://explorer.solana.com/tx/${signature}?cluster=devnet`;
      console.log("Проверьте транзакцию в блокчейне:", explorerLink);
      alert(`Транзакция отправлена! Проверьте: ${explorerLink}`);

      // Отправка вебхука
      await fetch("https://grafflasher.online/transaction-webhook", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ signature }),
      });
    } catch (err) {
      console.error("Ошибка при отправке токенов:", err);
      alert("Не удалось отправить токены. Проверьте лог в консоли.");
    }
  };

  return (
    <GearBackground>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '40px 320px',
          fontFamily: "'Segoe UI', system-ui, sans-serif",
          textAlign: 'center',
        }}
      >
        <h1
          style={{
            fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            fontWeight: 800,
            letterSpacing: '0.02em',
            marginBottom: 12,
            background: 'linear-gradient(135deg, #f0c060, #e08820)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Grafflasher
        </h1>
        <p style={{ opacity: 0.65, marginBottom: 40, fontSize: 16 }}>
          Добро пожаловать в Grafflasher!
        </p>

        {!walletAddress ? (
          <button
            onClick={connectWallet}
            style={{
              padding: '14px 36px',
              fontSize: 16,
              fontWeight: 700,
              borderRadius: 12,
              border: '1px solid rgba(240,192,96,0.40)',
              background: 'linear-gradient(135deg, rgba(240,192,96,0.18), rgba(224,136,32,0.22))',
              color: 'rgba(255,255,255,0.92)',
              cursor: 'pointer',
              transition: 'opacity 0.2s',
            }}
          >
            Підключити Phantom Wallet
          </button>
        ) : (
          <div
            style={{
              padding: '28px 36px',
              borderRadius: 18,
              border: '1px solid rgba(255,255,255,0.10)',
              background: 'rgba(255,255,255,0.04)',
              boxShadow: '0 18px 60px rgba(0,0,0,0.55)',
              minWidth: 320,
            }}
          >
            <p style={{ opacity: 0.70, marginBottom: 20, fontSize: 14, wordBreak: 'break-all' }}>
              Кошелек подключен:<br />
              <span style={{ opacity: 0.90, fontWeight: 600 }}>{walletAddress}</span>
            </p>
            <button
              onClick={sendTokens}
              style={{
                padding: '14px 36px',
                fontSize: 16,
                fontWeight: 700,
                borderRadius: 12,
                border: '1px solid rgba(240,192,96,0.40)',
                background: 'linear-gradient(135deg, rgba(240,192,96,0.18), rgba(224,136,32,0.22))',
                color: 'rgba(255,255,255,0.92)',
                cursor: 'pointer',
              }}
            >
              Відправити токени
            </button>
          </div>
        )}
      </div>
    </GearBackground>
  );
}

export default App;